<template>
  <div v-if="showBanner" class="env-banner">
    <div class="env-banner-content">
      <i class="el-icon-warning"></i>
      <span class="env-banner-text">
        <strong>Ambiente de pruebas</strong>
        <span class="env-banner-desc">
          — Los documentos emitidos no tienen validez fiscal
        </span>
      </span>
      <a class="env-banner-link" @click.prevent="goToConfig">
        Cambiar a produccion
        <i class="el-icon-arrow-right"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnvironmentBanner",
  computed: {
    user() {
      return this.$store.getters.getUser || {};
    },
    showBanner() {
      if (!this.user || !this.user.user_business) return false;
      return this.user.user_business.is_production === false;
    }
  },
  methods: {
    goToConfig() {
      this.$router
        .push({ path: "/dashboard/negocio", query: { tab: "signature" } })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.env-banner {
  background: #fff8e6;
  border-bottom: 1px solid #f0d68b;
  padding: 0 16px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 100;
}
.env-banner-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #854f0b;

  > i {
    font-size: 14px;
    flex-shrink: 0;
  }
}
.env-banner-text {
  strong {
    font-weight: 700;
  }
}
.env-banner-desc {
  @media (max-width: 768px) {
    display: none;
  }
}
.env-banner-link {
  font-weight: 600;
  color: #854f0b;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: underline;
  margin-left: 4px;

  &:hover {
    color: #6b3d06;
  }

  i {
    font-size: 11px;
  }
}
</style>
